import { defineMessages } from 'react-intl-next';

const messages = defineMessages({
	errorTitle: {
		id: 'eoc.alert-list.flag.error-title',
		defaultMessage: 'Error',
		description: 'Title of error message that will be displayed in the flag',
	},
	successTitle: {
		id: 'eoc.alert-list.flag.success-title',
		defaultMessage: 'Success',
		description: 'Title of success message that will be displayed in the flag',
	},
	acknowledge: {
		id: 'eoc.alert-list.actions.acknowledge',
		defaultMessage: 'Ack',
		description: 'Acknowledge action button',
	},
	unacknowledge: {
		id: 'eoc.alert-list.actions.unacknowledge',
		defaultMessage: 'Open',
		description: 'Unacknowledge(open) action button',
	},
	snooze: {
		id: 'eoc.alert-list.actions.snooze',
		defaultMessage: 'Snooze',
		description: 'Snooze action button',
	},
	close: {
		id: 'eoc.alert-list.actions.close',
		defaultMessage: 'Close',
		description: 'Close action button',
	},
	delete: {
		id: 'eoc.alert-list.actions.delete',
		defaultMessage: ' Delete',
		description: 'Delete action button',
	},
	escalateToNext: {
		id: 'eoc.alert-list.actions.escalateToNext',
		defaultMessage: 'Escalate to next',
		description: 'Escalate to next action button',
	},
	assign: {
		id: 'eoc.alert-list.actions.assign',
		defaultMessage: 'Assign',
		description: 'Assign action button',
	},
	addResponder: {
		id: 'eoc.alert-list.actions.add-responder',
		defaultMessage: 'Add responder',
		description: 'Add responder action button',
	},
	takeOwnership: {
		id: 'eoc.alert-list.actions.takeOwnership',
		defaultMessage: 'Assign to me',
		description: 'Assign to me action button',
	},
	addTag: {
		id: 'eoc.alert-list.actions.add-tag',
		defaultMessage: 'Add tag',
		description: 'Add tag action button',
	},
	addNote: {
		id: 'eoc.alert-list.actions.add-note',
		defaultMessage: 'Add note',
		description: 'Add note action button',
	},
	empty: {
		id: `eoc.alert-list.empty`,
		defaultMessage: 'No matching alerts were found.',
		description:
			'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
	},
	emptyNew: {
		id: `eoc.alert-list.empty`,
		defaultMessage: 'We couldn’t find any alerts matching your search',
		description:
			'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert with ff on.',
	},
	noAlerts: {
		id: `eoc.alert-list.no-alerts`,
		defaultMessage: 'You don’t have any alerts, yet',
		description: 'Message displayed when there is no alerts',
	},
	learnMore: {
		id: `eoc.alert-list.no-alerts.learn-more`,
		defaultMessage: 'Read how alerts are created',
		description: 'Message displayed for redirecting user to alert create docs',
	},
	emptyDescription: {
		id: `eoc.alert-list.no-alerts.description`,
		defaultMessage:
			'We couldn’t find any alerts for this search. Change your filters and try again.',
		description: 'Message displayed as description when there is no alerts with given search',
	},
	emptyDescriptionNew: {
		id: `eoc.alert-list.no-alerts.description`,
		defaultMessage:
			'Adjust your search filters and try again. You can also create an alert to notify your team about anything critical.',
		description:
			'Message displayed as description when there is no alerts with given search when ff on',
	},
	noAlertsDescription: {
		id: `eoc.alert-list.no-alerts.description`,
		defaultMessage:
			'Alerts can be symptoms of potential incidents or issues. Integrate your applications so you never miss a critical alert.',
		description: 'Message displayed when there is no alerts',
	},
	error: {
		id: `eoc.alert-list.error`,
		defaultMessage: 'We couldn’t load the alerts',
		description: 'Message displayed when there is an error on fetching alerts',
	},
	errorDescription: {
		id: `eoc.alert-list.error.description`,
		defaultMessage: 'Something went wrong while we were loading the alerts. Try searching again.',
		description: 'Message displayed as description when there is an error on fetching alerts',
	},
	pageTitle: {
		id: 'eoc.alert-list.page.title',
		defaultMessage: 'Alerts',
		description: 'Title of the page',
	},
	emptyAIViewTitle: {
		id: 'eoc.alert-list.flag.error-title',
		defaultMessage: 'Looking for alerts to group',
		description: 'Title ofthe message that will be displayed when no groups are present',
	},
	emptyAIViewDescription: {
		id: 'eoc.alert-list.flag.success-title',
		defaultMessage:
			'Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
		description: 'Description of the message that will be displayed when no groups are present',
	},
	dareAIViewTitle: {
		id: 'eoc.alert-list.flag.dare-title',
		defaultMessage: 'Starting fresh to group alerts',
		description:
			'Title of the message that will be displayed when no groups are present because of DaRe',
	},
	dareAIViewDescription: {
		id: 'eoc.alert-list.flag.dare-description',
		defaultMessage:
			'Since you changed your data residency location, previous alert groups were deleted. Rovo is working behind the scenes and will update this space as soon as new groups are identified.',
		description: 'Description of the message that will be displayed when no groups are present',
	},
	notEnabledAIViewTitle: {
		id: 'eoc.smart-alert-list.flag.not-enabled',
		defaultMessage: 'We couldn’t find what you’re looking for',
		description: 'Title of the message that will be displayed when AI view is not enabled',
	},
	notEnabledAIViewDescription: {
		id: 'eoc.smart-alert-list.flag.not-enabled',
		defaultMessage: 'We looked everywhere, but it doesn’t exist.',
		description: 'Description of the message that will be displayed when AI view is not enabled',
	},
	readMoreAlertGrouping: {
		id: 'eoc.alert-list.flag.success-title',
		defaultMessage: 'Read more about alert grouping',
		description: 'Message for read more that will be displayed when no groups are present',
	},
	requiredFieldsInformMessage: {
		id: 'eoc.alert-list.modal.required-fields-inform-message',
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Message to give information to users about required fields',
	},
	ariaLiveMessageFilters: {
		id: `eoc.alert-list.filters.aria-live-message`,
		defaultMessage: `{removedValue, select,
      true { Option {label} deselected. {numOfAlerts} matching alerts found. }
      other { Option {label} selected. {numOfAlerts} matching alerts found. }
    }`,
		description: 'The message to be announced when user selects an option from one of the filters.',
	},
	buttonAriaLabelToIndicateTableModification: {
		id: `eoc.alert-list.filters.update-button`,
		defaultMessage: '{buttonText}. The table will be modified.',
		description: 'The message to be announced before user press update filter button.',
	},
	acceptAIPrediction: {
		id: 'eoc.alert-list.unified-bulk-actions.accept-ai-prediction',
		defaultMessage: 'Accept classification',
		description: 'Button label for accepting AI prediction in bulk actions',
	},
	acknowledgeAll: {
		id: 'eoc.unified-list.actions.acknowledge',
		defaultMessage: 'Ack all',
		description: 'Acknowledge action button',
	},
	snoozeAll: {
		id: 'eoc.unified-list.actions.snooze',
		defaultMessage: 'Snooze all',
		description: 'Snooze action button',
	},
	closeAll: {
		id: 'eoc.unified-list.actions.close',
		defaultMessage: 'Close all',
		description: 'Close action button',
	},
	deleteAll: {
		id: 'eoc.unified-list.actions.delete',
		defaultMessage: 'Delete all',
		description: 'Delete action button',
	},
	assignToMe: {
		id: 'eoc.unified-list.actions.assignToMe',
		defaultMessage: 'Assign to me',
		description: 'Assign to me action button',
	},
	acceptPrediction: {
		id: 'eoc.unified-list.actions.acceptPrediction',
		defaultMessage: 'Accept classification',
		description: 'Accept classification action button',
	},
	moreAriaLabel: {
		id: 'eoc.unified-list.actions.more-aria-label',
		defaultMessage: 'More actions for {tinyId}',
		description: 'Description inside delete modal body.',
	},
	summaryMoreAriaLabel: {
		id: 'eoc.alert-list.summary-actions.more-aria-label',
		defaultMessage: 'More actions for alert {tinyId}',
		description: 'Aria label for the more actions button in summary',
	},
	deleteModalTitle: {
		id: 'eoc.alert-list.summary-actions.delete-modal-title',
		defaultMessage: 'Delete alert',
		description: 'Title for the delete confirmation modal',
	},
	deleteModalDescription: {
		id: 'eoc.alert-list.summary-actions.delete-modal-description',
		defaultMessage: 'Are you sure you want to delete this alert? This action cannot be undone.',
		description: 'Description for the delete confirmation modal',
	},
	filterInfo: {
		id: 'eoc.alert-list.header.filter-info',
		defaultMessage:
			"The results include groups that have alerts matching your filter criteria. The group's overall priority may differ.",
		description: 'Filter info in the alert smart table header',
	},
});

export default messages;
